import {Box, Heading, VStack} from 'platform/foundation';

interface FastTrackTableHeaderProps {
  children?: string;
}

export function FastTrackTableHeader(props: FastTrackTableHeaderProps) {
  return (
    <Box
      height={10}
      borderTop="solid 1px"
      borderColor="general.separator"
      backgroundColor="general.white"
      paddingTop={2}
      paddingBottom={2}
    >
      <Box paddingLeft={4} height="100%" borderRight="solid 1px" borderColor="general.separator">
        <VStack height="100%">
          <Heading align="left" size={5} alternative>
            {props.children}
          </Heading>
        </VStack>
      </Box>
    </Box>
  );
}
